<ng-container *ngLet="recs?.length == 1 && recs[0]['__action_queued'] as allQueued">
  <div *ngIf="!(isProcessing$|async) && !isPeerProcessingAll && !allQueued; else isProcessingTemplate;"
    class="d-flex flex-row justify-content-between my-auto">
    <div class="btn-group ml-auto" style="margin-right:2px;">
      <div class="btn-group" dropdown container="body" placement="bottom right" [dropup]="false"
        [isDisabled]="(isProcessing$|async) || !recs || recs.length === 0"
        (onHidden)="onDropdownHidden()" (onShown)="onDropdownShown()">
        <button dropdownToggle type="button" class="btn btn-sm btn-info dropdown-toggle"
          [disabled]="(isProcessing$|async) || !recs || recs.length === 0">
          <span class="caret">{{title}}</span>
        </button>
        <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
          <li role="menuitem" *ngFor="let action of rowActions;" [ngClass]="action.cssClass">
            <a class="dropdown-item" href="javascript:false;" (click)="doAction(action);"
               [title]="action.tooltipText || ''">{{action.title}}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <ng-template #isProcessingTemplate>
    <div class="d-flex flex-row">
      <button class="btn btn-sm btn-info" disabled="true">
        <ng-container *ngIf="!allQueued">
          <i class="fa fa-spinner fa-spin"></i> {{activeAction?.title}}
        </ng-container>
        <ng-container *ngIf="allQueued">
          <i class="fa fa-layer-group"></i> {{recs[0]['__action_queued']}}
        </ng-container>
      </button>
    </div>
  </ng-template>
</ng-container>